module.exports = "/_next/static/images/ke-5d45eaae039ee035b9efcd8d39a51c16.svg";